module.exports = __webpack_public_path__ + "static/media/Visa-dark.55cc6f70.svg";